require("../../node_modules/jquery-match-height/dist/jquery.matchHeight.js");

module.exports = {
  init: () => {
    $(".collage-image--normal, .collage-content").matchHeight({
      target: $(".collage-content"),
      byRow: false
    });
    $(".collage-image--large").matchHeight({
      target: $(".collage-image--target")
    });
  }
};
